import { FlowForm } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';
import { getMode } from '../connector/auth';
import './HeaderAuthButtons.css';

// "Log in" / "Sign up" header button pair, shown only in anonymous mode (renders nothing
// when logged in). By default wrapped in a FlowForm so the buttons join keyboard navigation
// when used as PageHeader rightContent; `bare` skips the wrapper for callers whose header
// already is (or sits inside) a FlowForm.
const HeaderAuthButtons: React.FC<{ bare?: boolean }> = ({ bare }) => {
  if (getMode() != 'anon') return null;
  const buttons = (
    <>
      <TextButton className="headerAuthBtn" label="Log in" type="minor" size="small" focussable="sideway" onClick={() => { window.location.href = '/login'; }} />
      <TextButton className="headerAuthBtn headerAuthSignup" label="Sign up" type="major" size="small" focussable="sideway" onClick={() => { window.location.href = '/signup'; }} />
    </>
  );
  if (bare) return buttons;
  return <FlowForm className="headerAuthForm">{buttons}</FlowForm>;
};

export default HeaderAuthButtons;
